import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '@/components/ConfirmationModal';
import { showError } from '@/utils';
import { reactivateSubscription } from '@/store/billing/thunks';

export function ReactivateSubscriptionModal({ onClose, ...props }) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	async function handleConfirm() {
		try {
			setLoading(true);

			await dispatch(reactivateSubscription()).unwrap();
		} catch (error) {
			showError(error);
		} finally {
			setLoading(false);
			onClose();
		}
	}

	return (
		<ConfirmationModal
			loading={loading}
			text={t('billing.subscription.reactivateConfirmation')}
			confirmText={t('billing.yesReactivate')}
			onConfirm={handleConfirm}
			onClose={onClose}
			{...props}
		/>
	);
}
